<template>
  <tabs
    v-if="accom"
    :tab-name="['Detail', 'Reservations', 'Notes']"
    :tab-icon="['event_available', 'book_online', 'text_snippet']"
    class="page-subcategories"
    nav-pills-icons
    color-button="primary"
  >
    <template slot="tab-pane-1">
      <accom-edit :accom="accom" />
    </template>

    <template slot="tab-pane-2">
      <accom-tabs-reservations :accom="accom" />
    </template>

    <template slot="tab-pane-3">
      <accom-tabs-notes :accom="accom" />
    </template>
  </tabs>
</template>

<script>
import { Tabs } from "@/components";

import AccomEdit from "./AccomEdit";
import AccomTabsReservations from "./AccomTabsReservations";
import AccomTabsNotes from "./AccomTabsNotes";

export default {
  props: ["accom"],

  components: {
    Tabs,
    AccomEdit,
    AccomTabsReservations,
    AccomTabsNotes
  },

  data() {
    return {};
  },

  computed: {},

  methods: {}
};
</script>
